export const complexityLevels = {
  contour_complexity_level: 'contour_complexity_level',
  color_complexity_level: 'color_complexity_level',
};
